import { addSourceToVideo } from "./helpers";
import { breakpoints } from "../helpers/breakpoints";

export const videoLoad = () => {
  //get all vids
  const video = document.querySelectorAll(".js-video-loader");

  //determine screen size and select mobile or desktop vid
  function whichSizeVideo(element, src) {
    if (window.innerWidth >= breakpoints.screen1024) {
      if (src.dataset.desktopVid) {
        addSourceToVideo(element, src.dataset.desktopVid);
      }
    } else {
      if (src.dataset.mobileVid) {
        addSourceToVideo(element, src.dataset.mobileVid);
      }
    }
  }

  //init only if page has videos
  function videoSize() {
    if (video !== undefined) {
      video.forEach(function (element) {
        whichSizeVideo(
          element, //element
          element //src locations
        );
      });
    }
  }

  window.addEventListener("resize", () => {
    videoSize();
  });

  window.dispatchEvent(new Event("resize"));
};
